import ZkSystemOptSaveOrUpdate from './src/main'
ZkSystemOptSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkSystemOptSaveOrUpdate.name, ZkSystemOptSaveOrUpdate)
}
export default ZkSystemOptSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/systemOptSaveOrUpdate/index.js